import getJsonLdScriptId from "@insite/client-framework/Common/Utilities/getJsonLdScriptId";
import prepareBreadcrumbStructuredPageData from "@insite/client-framework/Common/Utilities/prepareBreadcrumbStructuredPageData";
import { LinkProps } from "@insite/mobius/Link";
import useStructuredData from "@store/Framework/Common/Hooks/useStructuredData";
import { useSettingsCollection } from "@store/Framework/Store/Context/ContextHooks";
import { useCurrentPage } from "@store/Framework/Store/Data/Pages/PageHooks";
import { FC, useEffect, useState } from "react";

/* ---------------------------------------------------------------------------------------------------- */
// https://developers.google.com/search/docs/appearance/structured-data/breadcrumb
/* ---------------------------------------------------------------------------------------------------- */

export interface BreadcrumbStructuredDataProps {
    links: LinkProps[] | undefined;
}

const BreadcrumbStructuredData: FC<BreadcrumbStructuredDataProps> = ({ links }) => {
    const [structuredData, setStructuredData] = useState<string>();

    const {
        websiteSettings: { enableBreadcrumbStructuredData },
    } = useSettingsCollection();
    const { type } = useCurrentPage();
    const jsonLdScriptId = getJsonLdScriptId(type);

    useEffect(() => {
        if (
            !enableBreadcrumbStructuredData ||
            jsonLdScriptId === "breadcrumb-structured-data" ||
            !links?.length ||
            typeof window === "undefined"
        ) {
            return;
        }
        setStructuredData(prepareBreadcrumbStructuredPageData(links));
    }, [links]);

    useStructuredData(structuredData);

    return null;
};

export default BreadcrumbStructuredData;
